<template>
    <div>
        <sub-menu-call-center ativo="reservas" v-if="!cc" />

        <div class="form-row">
            <div class="col col-12 col-md-9">
                <az-input icon="fas fa-search fa-fw" v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary" :disabled="$store.state.loading" @click="load()">
                                <i class="fas fa-sync-alt"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    type="checkbox-group"
                    label="Meus Horários"
                    v-model="filtros.meus" />
            </div>
            
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>    


        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum horário em marcação encontrado.'" 
                icon="fa-solid fa-calendar-circle-user" />
		</div>

        <div v-if="lista && lista.length" id="lista-reservas">

            <div class="card mb-2 w3-animate-opacity carde" v-for="(dado, iq) in lista" :key="iq">
                <div class="card-body p-1 px-2">
                    <div class="row">
                        <!-- Ação -->
                        <div class="col col-12 col-md-2">
                            <div v-if="dado.created_at" title="Criada em..."><i class="fa-solid fa-circle-plus fa-fw"></i> {{ $util.getFormatDate(dado.created_at) }} {{ dado.created_at.slice(11,16) }}</div>
                            <div v-if="dado.dt_limite_reserva" title="Expira em..."><i class="fa-solid fa-hourglass-end fa-fw"></i> {{ $util.getFormatDate(dado.dt_limite_reserva) }} {{ dado.dt_limite_reserva.slice(11,16) }}</div>
                        </div>

                        <div class="col col-12 col-md-2">
                            <div title="Reservado para...">
                                <template v-if="dado.dt_data">
                                    {{ $util.getFormatDate(dado.dt_data) }} {{ dado.st_hora }}
                                </template>
                                <template v-else>
                                    {{ dado.st_slug_horario }}
                                </template>

                                <span v-if="dado.fl_fixo" class="ml-2">
                                    <i class="fa-solid fa-lock fa-fw text-secondary"></i>
                                </span>
                            </div>
                            <div class="small text-muted" title="Id da reserva">#{{ dado.id_reserva_horario }}</div>
                        </div>

                        <div class="col col-12 col-md-3">
                            <div title="Profissional">{{ dado.medico ? dado.medico.search : '-' }}</div>
                            <div title="Local">{{ dado.local ? dado.local.search : '' }}</div>
                        </div>

                        <div class="col col-12 col-md-3">
                            <div v-if="dado.usuario" title="Usuário criador da reserva">
                                <span :class="dado.usuario.id_usuario == $store.state.user.id_usuario ? 'badge badge-primary' : 'badge badge-secondary'">
                                    {{ dado.usuario.search }}
                                </span>
                            </div>
                            <div v-if="dado.paciente" title="Paciente">
                                {{ dado.paciente.st_nome }}
                            </div>
                            <div class="small text-muted" v-if="dado.st_obs" title="Observação">{{ dado.st_obs }}</div>
                        </div>

                        <div class="col col-12 col-md-2 d-flex align-items-center justify-content-end">
                            <a href="#" @click.prevent="remover(dado)">
                                <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import SubMenuCallCenter from './SubMenuCallCenter.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            filtros: { 
                meus: "",
            },
        }
    },

    props: ['cc'], 

    components: { 
        SubMenuCallCenter,
        AzInput, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados ? 
                this.dados.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];
        }
    },

    methods: { 
        remover (item) { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( !confirm ('Confirma remover a reserva?') ) 
                return; 

            this.$util.remover (this, { 
                service: 'reserva_horarios',
                dados: { 
                    id_reserva_horario: item.id_reserva_horario,
                },
                reload: true, 
            });
            
        },

        load () { 
            this.$util.load(this, { 
                service: 'reserva_horarios', 
                parms: { 
                    ...this.filtros, 
                }
            });
        },

    },
        
    mounted () {
        this.$store.commit("setBreadcrumb", [
            { name: "Call Center", path: "/call-center" },
            { name: "Horários em Marcação", path: "/call-center/reservas" }
        ]);

        this.load ();
    },

    updated () { 
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }
}
</script>